import { QuizAttemptStatus, QuizQuestionType } from '@/types/quizzes'

export function labelForQuizQuestionType(type: QuizQuestionType): string {
  switch (type) {
    case 'mcq':
      return 'Single answer'
    case 'multi':
      return 'Multiple answers'
    case 'numeric':
      return 'Numeric'
    case 'short_answer':
      return 'Short answer'
    case 'file_upload':
      return 'File upload'
    default:
      return type
  }
}

export function labelForQuizAttemptStatus(status: QuizAttemptStatus): string {
  switch (status) {
    case 'draft':
      return 'Draft'
    case 'in_progress':
      return 'In progress'
    case 'submitted':
      return 'Submitted'
    case 'graded':
      return 'Graded'
    case 'expired':
      return 'Expired'
    default:
      return status
  }
}
